import ReactivateRegistration from './ReactivateRegistration'

export default ReactivateRegistration
